import React, { useEffect, useRef, useState } from 'react';
import TacticEngine3D from './TacticEngine3D';

const MODES = [
    { key: 'tv',   label: 'TV',  title: 'Broadcast camera — follows the play' },
    { key: 'free', label: '3D',  title: 'Free camera — drag to orbit' },
    { key: 'top',  label: 'TOP', title: 'Top-down tactical view' },
];

export default function PublicCanvas3D({ tactic, currentTime }) {
    const containerRef = useRef(null);
    const engineRef    = useRef(null);
    const [mode, setMode] = useState('tv');

    // Mount engine once
    useEffect(() => {
        if (!containerRef.current) return;
        const engine = new TacticEngine3D(containerRef.current, { onCameraModeChange: setMode });
        engineRef.current = engine;
        return () => { engine.destroy(); engineRef.current = null; };
    }, []);

    // Drive engine on every render (no dep array — runs after every React update)
    useEffect(() => {
        if (engineRef.current) {
            engineRef.current.update(tactic, currentTime);
        }
    });

    const selectMode = (key) => {
        if (!engineRef.current) return;
        if (key === mode && key !== 'tv') engineRef.current.resetCamera();
        else engineRef.current.setCameraMode(key);
        setMode(key);
    };

    const btnBase = {
        background:     'transparent',
        border:         'none',
        color:          '#c9dcf5',
        padding:        '0.3rem 0.7rem',
        fontSize:       '0.72rem',
        fontWeight:     700,
        letterSpacing:  '0.07em',
        cursor:         'pointer',
        userSelect:     'none',
        transition:     'background 0.15s, color 0.15s',
    };

    return (
        <div style={{ position: 'absolute', inset: 0 }}>
            <div ref={containerRef} style={{ width: '100%', height: '100%' }} />

            {/* Camera mode — top-right corner */}
            <div style={{
                position:       'absolute',
                top:            '0.75rem',
                right:          '0.75rem',
                display:        'flex',
                background:     'rgba(10, 22, 40, 0.82)',
                border:         '1px solid rgba(255,255,255,0.22)',
                borderRadius:   '6px',
                overflow:       'hidden',
                backdropFilter: 'blur(4px)',
            }}>
                {MODES.map(m => (
                    <button
                        key={m.key}
                        onClick={() => selectMode(m.key)}
                        title={m.title}
                        style={{
                            ...btnBase,
                            background: mode === m.key ? 'rgba(61,140,255,0.85)' : 'transparent',
                            color:      mode === m.key ? '#ffffff' : '#c9dcf5',
                        }}
                    >
                        {m.label}
                    </button>
                ))}
            </div>

            {/* Gesture hint — only for the free camera */}
            {mode === 'free' && (
                <div style={{
                    position:   'absolute',
                    bottom:     '5rem',
                    left:       '50%',
                    transform:  'translateX(-50%)',
                    color:      'rgba(255,255,255,0.35)',
                    fontSize:   '0.68rem',
                    pointerEvents: 'none',
                    userSelect: 'none',
                    textAlign:  'center',
                    letterSpacing: '0.04em',
                }}>
                    drag to orbit · scroll to zoom · right-drag to pan
                </div>
            )}
        </div>
    );
}
